import { render, staticRenderFns } from "./DeviceLink.vue?vue&type=template&id=56cf790b&scoped=true"
import script from "./DeviceLink.vue?vue&type=script&lang=js"
export * from "./DeviceLink.vue?vue&type=script&lang=js"
import style0 from "./DeviceLink.vue?vue&type=style&index=0&id=56cf790b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf790b",
  null
  
)

export default component.exports